import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useAppToast from '@/hooks/useAppToast';
import { getApiErrorMessage, isNotFoundError } from '@/utils/apiError';
import { deleteInformation } from '@/services/admin/informations';

export const useDeleteInformation = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteInformation(currentSite, id),
    meta: { suppressNotFoundToast: true },
    onSuccess: data => {
      if (data?.success) {
        toast.success(data.message || '削除しました。');
        queryClient.invalidateQueries({ queryKey: ['admin', 'informations', currentSite] });
      }
    },
    onError: err => {
      if (isNotFoundError(err)) {
        toast.success('削除しました。');
        queryClient.invalidateQueries({ queryKey: ['admin', 'informations', currentSite] });
        return;
      }
      toast.error(getApiErrorMessage(err, 'エラーが発生しました。'));
    },
  });
};
